import axios, { AxiosInstance } from 'axios';
import environment from '@shared/environments/environment';
import { TOKEN_NAME } from '@shared/models/constants';

export default class ApiService {
  instance: AxiosInstance;

  controllerPath: string;

  constructor(controllerPath: string) {
    this.controllerPath = controllerPath;
    this.instance = axios.create({
      baseURL: environment.baseUri,
      withCredentials: false,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
    this.instance.interceptors.request.use((config) => ({
      ...config,
        headers: {
      ...config.headers,
          Authorization: localStorage.getItem(TOKEN_NAME)
      }
    }));
  }

  get(url: string, ...opts: any[]): Promise<any> {
    return this.instance.get(
      `${this.controllerPath}${url}`,
      ...opts,
    );
  }

  post(url: string, ...opts: any[]): Promise<any> {
    return this.instance.post(
      `${this.controllerPath}${url}`,
      ...opts,
    );
  }

  put(url: string, ...opts: any[]): Promise<any> {
    return this.instance.put(
      `${this.controllerPath}${url}`,
      ...opts,
    );
  }

  delete(url: string, ...opts: any): Promise<void> {
    return this.instance.delete(
      `${this.controllerPath}${url}`,
      ...opts,
    );
  }
}
